/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CoverageEligibilityRequestInfo } from '../models';
// @ts-ignore
import type { CoveragePatchModel } from '../models';
// @ts-ignore
import type { CoveragePostModel } from '../models';
// @ts-ignore
import type { CoveragePostResponseModel } from '../models';
// @ts-ignore
import type { CoverageResponseModel } from '../models';
// @ts-ignore
import type { GetCoverage200Response } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * FHIRCoverageApi - axios parameter creator
 * @export
 */
export const FHIRCoverageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a coverage
         * @summary Delete a coverage
         * @param {string} coverageId 
         * @param {string} [versionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoverage: async (coverageId: string, versionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverageId' is not null or undefined
            assertParamExists('deleteCoverage', 'coverageId', coverageId)
            const localVarPath = `/api/v1/fhir/coverage/{coverageId}`
                .replace(`{${"coverageId"}}`, encodeURIComponent(String(coverageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (versionId !== undefined) {
                localVarQueryParameter['versionId'] = versionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated coverage list
         * @summary Get paginated coverage list
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoverage: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getCoverage', 'patientId', patientId)
            const localVarPath = `/api/v1/fhir/coverage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get coverage eligibility request info
         * @summary Get coverage eligibility request info
         * @param {string} coverageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoverageEligibilityRequestInfo: async (coverageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverageId' is not null or undefined
            assertParamExists('getCoverageEligibilityRequestInfo', 'coverageId', coverageId)
            const localVarPath = `/api/v1/fhir/coverage/{coverageId}/eligibilityRequestInfo`
                .replace(`{${"coverageId"}}`, encodeURIComponent(String(coverageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a coverage
         * @summary Update a coverage
         * @param {string} coverageId 
         * @param {CoveragePatchModel} coveragePatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCoverage: async (coverageId: string, coveragePatchModel: CoveragePatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverageId' is not null or undefined
            assertParamExists('patchCoverage', 'coverageId', coverageId)
            // verify required parameter 'coveragePatchModel' is not null or undefined
            assertParamExists('patchCoverage', 'coveragePatchModel', coveragePatchModel)
            const localVarPath = `/api/v1/fhir/coverage/{coverageId}`
                .replace(`{${"coverageId"}}`, encodeURIComponent(String(coverageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coveragePatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a coverage
         * @summary Create a coverage
         * @param {string} patientId 
         * @param {CoveragePostModel} coveragePostModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCoverage: async (patientId: string, coveragePostModel: CoveragePostModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('postCoverage', 'patientId', patientId)
            // verify required parameter 'coveragePostModel' is not null or undefined
            assertParamExists('postCoverage', 'coveragePostModel', coveragePostModel)
            const localVarPath = `/api/v1/fhir/coverage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coveragePostModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FHIRCoverageApi - functional programming interface
 * @export
 */
export const FHIRCoverageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FHIRCoverageApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a coverage
         * @summary Delete a coverage
         * @param {string} coverageId 
         * @param {string} [versionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCoverage(coverageId: string, versionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCoverage(coverageId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRCoverageApi.deleteCoverage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated coverage list
         * @summary Get paginated coverage list
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCoverage(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCoverage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCoverage(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRCoverageApi.getCoverage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get coverage eligibility request info
         * @summary Get coverage eligibility request info
         * @param {string} coverageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCoverageEligibilityRequestInfo(coverageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverageEligibilityRequestInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCoverageEligibilityRequestInfo(coverageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRCoverageApi.getCoverageEligibilityRequestInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a coverage
         * @summary Update a coverage
         * @param {string} coverageId 
         * @param {CoveragePatchModel} coveragePatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCoverage(coverageId: string, coveragePatchModel: CoveragePatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverageResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCoverage(coverageId, coveragePatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRCoverageApi.patchCoverage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a coverage
         * @summary Create a coverage
         * @param {string} patientId 
         * @param {CoveragePostModel} coveragePostModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCoverage(patientId: string, coveragePostModel: CoveragePostModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoveragePostResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCoverage(patientId, coveragePostModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRCoverageApi.postCoverage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FHIRCoverageApi - factory interface
 * @export
 */
export const FHIRCoverageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FHIRCoverageApiFp(configuration)
    return {
        /**
         * Delete a coverage
         * @summary Delete a coverage
         * @param {FHIRCoverageApiDeleteCoverageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoverage(requestParameters: FHIRCoverageApiDeleteCoverageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCoverage(requestParameters.coverageId, requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated coverage list
         * @summary Get paginated coverage list
         * @param {FHIRCoverageApiGetCoverageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoverage(requestParameters: FHIRCoverageApiGetCoverageRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCoverage200Response> {
            return localVarFp.getCoverage(requestParameters.patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get coverage eligibility request info
         * @summary Get coverage eligibility request info
         * @param {FHIRCoverageApiGetCoverageEligibilityRequestInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoverageEligibilityRequestInfo(requestParameters: FHIRCoverageApiGetCoverageEligibilityRequestInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoverageEligibilityRequestInfo> {
            return localVarFp.getCoverageEligibilityRequestInfo(requestParameters.coverageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a coverage
         * @summary Update a coverage
         * @param {FHIRCoverageApiPatchCoverageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCoverage(requestParameters: FHIRCoverageApiPatchCoverageRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoverageResponseModel> {
            return localVarFp.patchCoverage(requestParameters.coverageId, requestParameters.coveragePatchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a coverage
         * @summary Create a coverage
         * @param {FHIRCoverageApiPostCoverageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCoverage(requestParameters: FHIRCoverageApiPostCoverageRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoveragePostResponseModel> {
            return localVarFp.postCoverage(requestParameters.patientId, requestParameters.coveragePostModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FHIRCoverageApi - interface
 * @export
 * @interface FHIRCoverageApi
 */
export interface FHIRCoverageApiInterface {
    /**
     * Delete a coverage
     * @summary Delete a coverage
     * @param {FHIRCoverageApiDeleteCoverageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRCoverageApiInterface
     */
    deleteCoverage(requestParameters: FHIRCoverageApiDeleteCoverageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get paginated coverage list
     * @summary Get paginated coverage list
     * @param {FHIRCoverageApiGetCoverageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRCoverageApiInterface
     */
    getCoverage(requestParameters: FHIRCoverageApiGetCoverageRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCoverage200Response>;

    /**
     * Get coverage eligibility request info
     * @summary Get coverage eligibility request info
     * @param {FHIRCoverageApiGetCoverageEligibilityRequestInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRCoverageApiInterface
     */
    getCoverageEligibilityRequestInfo(requestParameters: FHIRCoverageApiGetCoverageEligibilityRequestInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoverageEligibilityRequestInfo>;

    /**
     * Update a coverage
     * @summary Update a coverage
     * @param {FHIRCoverageApiPatchCoverageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRCoverageApiInterface
     */
    patchCoverage(requestParameters: FHIRCoverageApiPatchCoverageRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoverageResponseModel>;

    /**
     * Create a coverage
     * @summary Create a coverage
     * @param {FHIRCoverageApiPostCoverageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRCoverageApiInterface
     */
    postCoverage(requestParameters: FHIRCoverageApiPostCoverageRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoveragePostResponseModel>;

}

/**
 * Request parameters for deleteCoverage operation in FHIRCoverageApi.
 * @export
 * @interface FHIRCoverageApiDeleteCoverageRequest
 */
export interface FHIRCoverageApiDeleteCoverageRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRCoverageApiDeleteCoverage
     */
    readonly coverageId: string

    /**
     * 
     * @type {string}
     * @memberof FHIRCoverageApiDeleteCoverage
     */
    readonly versionId?: string
}

/**
 * Request parameters for getCoverage operation in FHIRCoverageApi.
 * @export
 * @interface FHIRCoverageApiGetCoverageRequest
 */
export interface FHIRCoverageApiGetCoverageRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRCoverageApiGetCoverage
     */
    readonly patientId: string
}

/**
 * Request parameters for getCoverageEligibilityRequestInfo operation in FHIRCoverageApi.
 * @export
 * @interface FHIRCoverageApiGetCoverageEligibilityRequestInfoRequest
 */
export interface FHIRCoverageApiGetCoverageEligibilityRequestInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRCoverageApiGetCoverageEligibilityRequestInfo
     */
    readonly coverageId: string
}

/**
 * Request parameters for patchCoverage operation in FHIRCoverageApi.
 * @export
 * @interface FHIRCoverageApiPatchCoverageRequest
 */
export interface FHIRCoverageApiPatchCoverageRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRCoverageApiPatchCoverage
     */
    readonly coverageId: string

    /**
     * 
     * @type {CoveragePatchModel}
     * @memberof FHIRCoverageApiPatchCoverage
     */
    readonly coveragePatchModel: CoveragePatchModel
}

/**
 * Request parameters for postCoverage operation in FHIRCoverageApi.
 * @export
 * @interface FHIRCoverageApiPostCoverageRequest
 */
export interface FHIRCoverageApiPostCoverageRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRCoverageApiPostCoverage
     */
    readonly patientId: string

    /**
     * 
     * @type {CoveragePostModel}
     * @memberof FHIRCoverageApiPostCoverage
     */
    readonly coveragePostModel: CoveragePostModel
}

/**
 * FHIRCoverageApi - object-oriented interface
 * @export
 * @class FHIRCoverageApi
 * @extends {BaseAPI}
 */
export class FHIRCoverageApi extends BaseAPI implements FHIRCoverageApiInterface {
    /**
     * Delete a coverage
     * @summary Delete a coverage
     * @param {FHIRCoverageApiDeleteCoverageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRCoverageApi
     */
    public deleteCoverage(requestParameters: FHIRCoverageApiDeleteCoverageRequest, options?: RawAxiosRequestConfig) {
        return FHIRCoverageApiFp(this.configuration).deleteCoverage(requestParameters.coverageId, requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated coverage list
     * @summary Get paginated coverage list
     * @param {FHIRCoverageApiGetCoverageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRCoverageApi
     */
    public getCoverage(requestParameters: FHIRCoverageApiGetCoverageRequest, options?: RawAxiosRequestConfig) {
        return FHIRCoverageApiFp(this.configuration).getCoverage(requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get coverage eligibility request info
     * @summary Get coverage eligibility request info
     * @param {FHIRCoverageApiGetCoverageEligibilityRequestInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRCoverageApi
     */
    public getCoverageEligibilityRequestInfo(requestParameters: FHIRCoverageApiGetCoverageEligibilityRequestInfoRequest, options?: RawAxiosRequestConfig) {
        return FHIRCoverageApiFp(this.configuration).getCoverageEligibilityRequestInfo(requestParameters.coverageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a coverage
     * @summary Update a coverage
     * @param {FHIRCoverageApiPatchCoverageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRCoverageApi
     */
    public patchCoverage(requestParameters: FHIRCoverageApiPatchCoverageRequest, options?: RawAxiosRequestConfig) {
        return FHIRCoverageApiFp(this.configuration).patchCoverage(requestParameters.coverageId, requestParameters.coveragePatchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a coverage
     * @summary Create a coverage
     * @param {FHIRCoverageApiPostCoverageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRCoverageApi
     */
    public postCoverage(requestParameters: FHIRCoverageApiPostCoverageRequest, options?: RawAxiosRequestConfig) {
        return FHIRCoverageApiFp(this.configuration).postCoverage(requestParameters.patientId, requestParameters.coveragePostModel, options).then((request) => request(this.axios, this.basePath));
    }
}

